export class FunctionalHeader {
  distributionPartnerNumber: string;
  outletNumber: string;
}
